export default "__VITE_PUBLIC_ASSET__5722e958__"